import React, { useEffect, useMemo } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../_redux/user/userAction';
import * as uiHelpers from '../UserUIHelpers';

import {
    getHandlerTableChange,
    NoRecordsFoundMessage,
    PleaseWaitMessage,
} from '../../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';
import { Pagination } from '../../../../../../_metronic/_partials/controls';
import { useUserUIContext } from '../UserUIContext';
import { RoleChecker } from '../../../../../RoleChecker';

const UserTable = (props) => {
    // User UI Context
    const userUIContext = useUserUIContext();
    const userUIProps = useMemo(() => {
        return {
            queryParams: userUIContext.queryParams,
            setQueryParams: userUIContext.setQueryParams,
            openEditUserPage: userUIContext.openEditUserPage,
        };
    }, [userUIContext]);

    // Getting curret state of user list from store (Redux)
    const { currentState } = useSelector(
        (state) => ({ currentState: state.users }),
        shallowEqual,
    );

    const { totalCount, entities, listLoading } = currentState;

    const dispatch = useDispatch();
    useEffect(() => {

        //Requset ke Branch Action
        dispatch(actions.fetchUsers(userUIProps.queryParams));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userUIProps.queryParams, dispatch]);
    // console.log(entities);

    const allowEdit = RoleChecker('Edit', 'user')

    // Table columns
    const columns = [
        {
            dataField: 'name',
            text: 'Nama',
        },
        {
            dataField: 'email',
            text: 'Email',
        },
        {
            dataField: 'role',
            text: 'Role',
            formatter: columnFormatters.RoleColumnFormatter,
        },
        {
            dataField: 'is_active',
            text: 'Status',
            formatter: columnFormatters.StatusColumnFormatter,
        },
        {
            dataField: 'active_until',
            text: 'Aktif Sampai Dengan',
            formatter: columnFormatters.ActiveUntilColumnFormatter,
        },
        {
            dataField: 'action',
            text: 'Aksi',
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditUserPage: userUIProps.openEditUserPage, allowEdit
            },
            classes: 'text-right pr-0',
            headerClasses: 'text-right pr-3',
            style: {
                minWidth: '100px',
            },
        },
    ];

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: userUIProps.queryParams.pageSize,
        page: userUIProps.queryParams.pageNumber,
    };

    return (
        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({ paginationProps, paginationTableProps }) => {
                    return (
                        <Pagination
                            isLoading={listLoading}
                            paginationProps={paginationProps}
                        >
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                bootstrap4
                                bordered={false}
                                remote
                                keyField="uuid"
                                data={entities === null ? [] : entities}
                                // data={[]}
                                columns={columns}
                                onTableChange={getHandlerTableChange(
                                    userUIProps.setQueryParams,
                                )}
                                {...paginationTableProps}
                            >
                                <PleaseWaitMessage entities={entities} />
                                <NoRecordsFoundMessage entities={entities} />
                            </BootstrapTable>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
        </>
    );
};

export default UserTable;
